module.exports = __webpack_public_path__ + "img/Penny-Pinch-04.ab9173bf.jpg";